/**
 * default option
 */
const defaults = {
    src: "data-src",
    srcset: "data-srcset",
    selector: ".lazyload",
    root: null,
    rootMargin: "0px",
    threshold: 0
};
/**
 * @class LazyLoad
 */
export default class LazyLoad {
    constructor(elms, options) {
        this.opts = { ...defaults, ...options };
        this.elms = elms || document.querySelectorAll(this.opts.selector);
        this.init();
    }
    elms;
    obs = null;
    opts;
    init() {
        /* Without observers load everything and bail out early. */
        if (!IntersectionObserver) {
            this.load();
            return;
        }
        this.obs = new IntersectionObserver((entries) => {
            for (const entry of entries) {
                if (entry.isIntersecting) {
                    this.obs.unobserve(entry.target);
                    this.doLoad(entry.target);
                }
            }
        }, {
            root: this.opts.root,
            rootMargin: this.opts.rootMargin,
            threshold: [this.opts.threshold]
        });
        this.elms.forEach((image) => {
            this.obs.observe(image);
        });
    }
    load() {
        if (!this.opts) {
            return;
        }
        this.elms.forEach(this.doLoad);
    }
    doLoad = (element) => {
        const src = element.getAttribute(this.opts.src);
        const srcset = element.getAttribute(this.opts.srcset);
        const tagName = element.tagName.toLowerCase();
        if (src) {
            if (element.src === src || element.style.backgroundImage.includes(src)) {
                return;
            }
            if (tagName === 'video' || tagName === 'img') {
                element.src = src;
            }
            else {
                element.style.backgroundImage = "url('" + src + "')";
            }
        }
        if (tagName === 'img' && srcset) {
            element.srcset = srcset;
        }
    };
    /**
     * Destroy Lazyload Instance
     * @returns
     */
    destroy() {
        if (!this.opts) {
            return;
        }
        this.obs.disconnect();
        this.opts = null;
    }
}
export const lazyload = (images, options) => new LazyLoad(images, options);
